import { render, staticRenderFns } from "./FilterProductGridCard.vue?vue&type=template&id=9d2831a4&scoped=true&"
import script from "./FilterProductGridCard.vue?vue&type=script&lang=js&"
export * from "./FilterProductGridCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterProductGridCard.vue?vue&type=style&index=0&id=9d2831a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2831a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,BookOpen: require('/vercel/path0/components/icons/BookOpen.vue').default,ProductAuthors: require('/vercel/path0/components/product/ProductAuthors.vue').default,ProductPrice: require('/vercel/path0/components/product/ProductPrice.vue').default,ArrowLeft: require('/vercel/path0/components/icons/ArrowLeft.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
